import React, { useState, useEffect } from "react";
import DropdownValues from "../Student/Reusablecomponents/DropDownValues";
import axios from "axios";

export function MainSource(props) {
  const [MainSourceOptions, SetMainSourceOptions] = useState();

  const GetNTDetails = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=55&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetMainSourceOptions(Options);
        props.StoreMSource(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetNTDetails();
  }, []);

  return (
    <>
      <DropdownValues
        className={props.className}
        options={MainSourceOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        labelname={props.labelname}
        disabled={props.disable}
        Displayname="Select"
      />
    </>
  );
}

export function SubMainSource(props) {
  const [SubMainSourceOptions, SetSubMainSourceOptions] = useState();
  const GetNTDetails = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=56&ParentLovId=${props.PId}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetSubMainSourceOptions(Options);
        props.StoreSMSource(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.PId) {
      GetNTDetails();
    } else {
      SetSubMainSourceOptions();
      props.StoreSMSource("");
    }
  }, [props.PId]);
  return (
    <>
      <DropdownValues
        Displayname="Select"
        disabled={props.disable}
        className={props.className}
        options={SubMainSourceOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
      />
    </>
  );
}

export function QVStatus(props) {
  const [QVStatusOptions, SetQVStatusOptions] = useState();
  const QVStatus = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=45&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetQVStatusOptions(Options);
        props.StoreValue(props.SOption);
        // props.StoreValue(props.SOption || res.data[0].lovId);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    QVStatus();
  }, []);

  return (
    <>
      <DropdownValues
        className={props.className}
        options={QVStatusOptions}
        selectoption={props.SOption}
        Displayname="Select Question Status"
        onChange={(e) => props.onChange(e.target.value)}
        labelname={
          <div className="DropdownHeader">
            Question Verification Status<span>*</span>
          </div>
        }
      />
    </>
  );
}

export function DDContent(props) {
  const [ContentOptions, SetContentOptions] = useState();
  const GetContent = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=3&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetContentOptions(Options);
        // props.StoreValue(props.SOption || res.data[0].lovId);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId) {
      GetContent();
    } else {
      SetContentOptions();
      props.StoreValue("");
    }
  }, []);

  return (
    <DropdownValues
      disabled={props.disable}
      className={props.className}
      options={ContentOptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          Content<span>*</span>
        </div>
      }
      Displayname={props.Displayname}
    />
  );
}

export function DDTopic(props) {
  const [TopicOptions, SetTopicOptions] = useState();
  const GetTopic = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${
            props.SubjectId
          }&LovCategoryId=${props.LovCategoryId}&ParentLovId=${
            props.PId || 0
          }&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetTopicOptions(Options);
        let Selected = Options.find(
          (item) => item.value === parseInt(props.SOption)
        );
        props.StoreValue(Selected ? props.SOption : "");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId === "1" || (props.SubjectId && props.PId)) {
      GetTopic();
    } else {
      SetTopicOptions();
      props.StoreValue("");
    }
  }, [props.PId, props.LID]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      disabled={props.disable}
      className={props.className}
      options={TopicOptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={props.labelName}
    />
  );
}

export function DDSubTopic(props) {
  const [SubTopicOptions, SetSubTopicOptions] = useState();
  const GetSubTopic = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=${props.LovCategoryId}&ParentLovId=${props.PId}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetSubTopicOptions(Options);
        let Selected = Options.find(
          (item) => item.value === parseInt(props.SOption)
        );
        props.StoreValue(Selected ? props.SOption : "");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PId) {
      GetSubTopic();
    } else {
      SetSubTopicOptions();
      props.StoreValue("");
    }
  }, [props.PId]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      disabled={props.disable}
      className={props.className}
      options={SubTopicOptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={props.labelName}
    />
  );
}

export function DDLearningOC(props) {
  const [LearningOCOptions, SetLearningOCOptions] = useState();
  const GetLearningOC = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=${props.LovCategoryId}&ParentLovId=${props.PId}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetLearningOCOptions(Options);
        let Selected = Options.find(
          (item) => item.value === parseInt(props.SOption)
        );
        props.StoreValue(Selected ? props.SOption : "");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PId) {
      GetLearningOC();
    } else {
      SetLearningOCOptions();
      props.StoreValue("");
    }
  }, [props.PId]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      disabled={props.disable}
      className={props.className}
      options={LearningOCOptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={props.labelName}
    />
  );
}

export function DDSubLearningOC(props) {
  const [SubLearningOCOptions, SetSubLearningOCOptions] = useState();
  const GetSubLearningOC = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=${props.LovCategoryId}&ParentLovId=${props.PId}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetSubLearningOCOptions(Options);
        let Selected = Options.find(
          (item) => item.value === parseInt(props.SOption)
        );
        props.StoreValue(Selected ? props.SOption : "");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PId) {
      GetSubLearningOC();
    } else {
      SetSubLearningOCOptions();
      props.StoreValue("");
    }
  }, [props.PId]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      disabled={props.disable}
      className={props.className}
      options={SubLearningOCOptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={<div className="DropdownHeader">Sub Learning Outcomes</div>}
    />
  );
}

export function NCERTLO(props) {
  const [NCERTLOptions, SetNCERTLOptions] = useState();
  const GetNCERTLO = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=${props.LovCategoryId}&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetNCERTLOptions(Options);
        props.GetOptions(res.data);
        // props.StoreValue(props.SOption || res.data[0].lovId);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId) {
      GetNCERTLO();
    } else {
      SetNCERTLOptions();
      props.StoreValue("");
    }
  }, []);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      disabled={props.disable}
      options={NCERTLOptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={<div className="DropdownHeader">NCERT Learning Outcome</div>}
    />
  );
}

export function QuestionLevel(props) {
  const [QuestionLevelptions, SetQuestionLevelptions] = useState();
  const GetQuestionLevel = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=${props.LovCategoryId}&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetQuestionLevelptions(Options);
        // if (!props.Displayname) {
        //   props.StoreValue(props.SOption || res.data[0].lovId);
        // }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId) {
      GetQuestionLevel();
    }
  }, []);

  return (
    <DropdownValues
      disabled={props.disable}
      className={props.className}
      options={QuestionLevelptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={props.labelname}
      Displayname={props.Displayname}
    />
  );
}

export function BloomTaxonomy(props) {
  const [BloomTaxonomyptions, SetBloomTaxonomyptions] = useState();
  const GetBloomTaxonomy = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=${props.LovCategoryId}&ParentLovId=${props.PId}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetBloomTaxonomyptions(Options);
        props.StoreValue(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
        SetBloomTaxonomyptions();
        props.StoreValue();
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PId) {
      GetBloomTaxonomy();
    } else {
      SetBloomTaxonomyptions();
      props.StoreValue();
    }
  }, [props.PId]);
  return (
    <>
      <DropdownValues
        disabled={props.disable}
        className={props.className}
        options={BloomTaxonomyptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        labelname={props.labelname}
        Displayname={props.Displayname}
      />
    </>
  );
}

export function DDContext(props) {
  const [Contextptions, SetContextptions] = useState();
  const GetContext = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=9&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetContextptions(Options);
        // props.StoreValue(props.SOption || res.data[0].lovId);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId) {
      GetContext();
    } else {
      SetContextptions();
      props.StoreValue();
    }
  }, []);

  return (
    <DropdownValues
      disabled={props.disable}
      className={props.className}
      options={Contextptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          Context <span>*</span>
        </div>
      }
      Displayname={props.Displayname}
    />
  );
}

export function FormQuestions(props) {
  const [FormQuestionsOptions, SetFormQuestionsOptions] = useState();
  const GetFQuestions = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=65&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetFormQuestionsOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetFQuestions();
  }, []);
  return (
    <>
      <div className="dflex JSAround alignitems mt-2">
        {FormQuestionsOptions?.map((Forms, index) => (
          <div className="dflex alignitems" key={index} style={{ gap: "5px" }}>
            {/* {Forms.value} */}
            <input
              type="checkbox"
              value={Forms.value}
              checked={props.PostValues.includes(Forms.value)}
              onChange={(e) => props.onChange(Forms.value)}
              disabled={props.disable}
            />{" "}
            {Forms.display}
          </div>
        ))}
      </div>
    </>
  );
}

// Below are the Science Drop Downs

export function DDSystem(props) {
  const [SystemOptions, SetSystemOptions] = useState();
  const GetSystem = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=22&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        // alert("Qb Drop downs")
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetSystemOptions(Options);
        if(props.NCLAdmin){
           let Selected = Options.find(
          (item) => item.value === parseInt(props.SOption)
        );
        props.StoreValue(Selected ? props.SOption : "");
        }
        // props.StoreValue({
        //   ...props.SOption,
        //   System: props.SOption.System || res.data[0].lovId,
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId) {
      GetSystem();
    } else {
      SetSystemOptions();
      props.StoreValue();
    }
  }, []);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      disabled={props.disable}
      className={props.className}
      options={SystemOptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          System<span>*</span>
        </div>
      }
    />
  );
}

export function DDStream(props) {
  const [StreamOptions, SetStreamOptions] = useState();
  const GetStream = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=23&ParentLovId=${props.PId}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetStreamOptions(Options);
         if(props.NCLAdmin){
           let Selected = Options.find(
          (item) => item.value === parseInt(props.SOption)
        );
        props.StoreValue(Selected ? props.SOption : "");
        }
        // let Selected = Options.find(
        //   (item) => item.value === parseInt(props.SOption.Stream)
        // );
        // props.StoreValue({
        //   ...props.SOption,
        //   Stream: Selected ? props.SOption.Stream : res.data[0]?.lovId,
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PId) {
      GetStream();
    } else {
      SetStreamOptions();
      props.StoreValue("");
    }
  }, [props.PId]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      options={StreamOptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      disabled={props.disable}
      labelname={
        <div className="DropdownHeader">
          Stream<span>*</span>
        </div>
      }
    />
  );
}

export function DDSubSytem(props) {
  const [SubSytemOptions, SetSubSytemOptions] = useState();
  const GetSubSytem = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=24&ParentLovId=${props.PId}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetSubSytemOptions(Options);
         if(props.NCLAdmin){
           let Selected = Options.find(
          (item) => item.value === parseInt(props.SOption)
        );
        props.StoreValue(Selected ? props.SOption : "");
        }
        // let Selected = Options.find(
        //   (item) => item.value === parseInt(props.SOption.SubSytem)
        // );
        // props.StoreValue({
        //   ...props.SOption,
        //   SubSytem: Selected ? props.SOption.SubSytem : res.data[0]?.lovId,
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PId) {
      GetSubSytem();
    } else {
      SetSubSytemOptions();
      props.StoreValue("");
    }
  }, [props.PId]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      options={SubSytemOptions}
      disabled={props.disable}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          Sub-Sytem<span>*</span>
        </div>
      }
    />
  );
}

export function DDCompetencies(props) {
  const [CompetenciesOptions, SetCompetenciesOptions] = useState();
  const GetCompetencies = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=15&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetCompetenciesOptions(Options);
        // let Selected = Options.find(
        //   (item) => item.value === parseInt(props.SOption.Competencies)
        // );
        // props.StoreValue({
        //   ...props.SOption,
        //   Competencies: Selected
        //     ? props.SOption.Competencies
        //     : res.data[0]?.lovId,
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId) {
      GetCompetencies();
    } else {
      SetCompetenciesOptions();
      props.StoreValue();
    }
  }, []);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      options={CompetenciesOptions}
      disabled={props.disable}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          NSF Competencies<span>*</span>
        </div>
      }
    />
  );
}

export function DDSubCompetencies(props) {
  const [SubCompetenciesOptions, SetSubCompetenciesOptions] = useState();
  const GetSubCompetencies = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/ScienceQuestionBank/GetSubCompetencies?CompetencyId=${props.PId}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetSubCompetenciesOptions(Options);
        // let Selected = Options.find(
        //   (item) => item.value === parseInt(props.SOption.SubCompetencies)
        // );
        // props.StoreValue({
        //   ...props.SOption,
        //   SubCompetencies: Selected
        //     ? props.SOption.SubCompetencies
        //     : res.data[0]?.lovId,
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PId) {
      GetSubCompetencies();
    } else {
      SetSubCompetenciesOptions();
      props.StoreValue("");
    }
  }, [props.PId]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      options={SubCompetenciesOptions}
      disabled={props.disable}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          NSF Sub-Competencies<span>*</span>
        </div>
      }
    />
  );
}

export function DDProcedural(props) {
  const [ProceduralOptions, SetProceduralOptions] = useState();
  const GetProcedural = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=17&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetProceduralOptions(Options);
        // let Selected = Options.find(
        //   (item) => item.value === parseInt(props.SOption.Procedural)
        // );
        // props.StoreValue({
        //   ...props.SOption,
        //   Procedural: Selected ? props.SOption.Procedural : res.data[0]?.lovId,
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId) {
      GetProcedural();
    } else {
      SetProceduralOptions();
      props.StoreValue();
    }
  }, []);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      options={ProceduralOptions}
      disabled={props.disable}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          Procedural Knowledge<span>*</span>
        </div>
      }
    />
  );
}

export function DDEpistemic(props) {
  const [EpistemicOptions, SetEpistemicOptions] = useState();
  const GetEpistemic = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=18&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetEpistemicOptions(Options);
        // let Selected = Options.find(
        //   (item) => item.value === parseInt(props.SOption.Epistemic)
        // );
        // props.StoreValue({
        //   ...props.SOption,
        //   Epistemic: Selected ? props.SOption.Epistemic : res.data[0]?.lovId,
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PId) {
      GetEpistemic();
    } else {
      SetEpistemicOptions();
      props.StoreValue();
    }
  }, [props.PId]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      options={EpistemicOptions}
      disabled={props.disable}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          Epistemic Knowledge<span>*</span>
        </div>
      }
    />
  );
}

export function DDContextOne(props) {
  const [ContextOneOptions, SetContextOneOptions] = useState();
  const GetContextOne = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=19&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetContextOneOptions(Options);
        // let Selected = Options.find(
        //   (item) => item.value === parseInt(props.SOption.ContextOne)
        // );
        // props.StoreValue({
        //   ...props.SOption,
        //   ContextOne: Selected ? props.SOption.ContextOne : res.data[0]?.lovId,
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId) {
      GetContextOne();
    } else {
      SetContextOneOptions();
      props.StoreValue({
        ContextOne: "",
        ContextTwo: "",
        ContextThree: "",
      });
    }
  }, []);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      options={ContextOneOptions}
      disabled={props.disable}
      selectoption={props.SOption?.ContextOne}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          Context Level 1<span>*</span>
        </div>
      }
    />
  );
}

export function DDContextTwo(props) {
  const [ContextTwoOptions, SetContextTwoOptions] = useState();
  const GetContextTwo = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=20&ParentLovId=0&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetContextTwoOptions(Options);
        let Selected = Options.find(
          (item) => item.value === parseInt(props.SOption.ContextTwo)
        );
        if (parseInt(props.PId) === 3307) {
          props.StoreValue({
            ...props.SOption,
            ContextTwo: res.data[0]?.lovId,
          });
          // } else {
          //   props.StoreValue({
          //     ...props.SOption,
          //     ContextTwo: Selected
          //       ? props.SOption.ContextTwo
          //       : res.data[0]?.lovId,
          //   });
        }
      })

      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PId) {
      GetContextTwo();
    } else {
      SetContextTwoOptions();
      props.StoreValue({
        ...props.SOption,
        ContextTwo: "",
        ContextThree: "",
      });
    }
  }, [props.PId]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      options={ContextTwoOptions}
      selectoption={props.SOption?.ContextTwo}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          Context Level 2<span>*</span>
        </div>
      }
      disabled={parseInt(props.PId) === 3307}
    />
  );
}

export function DDContextThree(props) {
  const [ContextThreeOptions, SetContextThreeOptions] = useState();
  const GetContextThree = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/ScienceQuestionBank/GetContextLevel3ByIds?ContextLevel1=${props.PIdOne}&ContextLevel2=${props.PIdTwo}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.lovId) {
          const Options = res.data.map((item) => ({
            display: item.lovDescription,
            value: item.lovId,
          }));
          SetContextThreeOptions(Options);
          // let Selected = Options.find(
          //   (item) => item.value === parseInt(props.SOption.ContextThree)
          // );
          // props.StoreValue({
          //   ...props.SOption,
          //   ContextThree: Selected
          //     ? props.SOption.ContextThree
          //     : res.data[0]?.lovId,
          // });
        } else {
          SetContextThreeOptions();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PIdOne && props.PIdTwo) {
      GetContextThree();
    } else {
      SetContextThreeOptions();
      props.StoreValue({
        ...props.SOption,
        ContextTwo: "",
        ContextThree: "",
      });
    }
  }, [props.PIdOne, props.PIdTwo]);
  return (
    <DropdownValues
      Displayname={props.Displayname}
      className={props.className}
      options={ContextThreeOptions}
      disabled={props.disable}
      selectoption={props.SOption?.ContextThree}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={
        <div className="DropdownHeader">
          Context Level 3<span>*</span>
        </div>
      }
    />
  );
}

export function QBTopic(props) {
  const [TopicOptions, SetTopicOptions] = useState();
  const GetTopic = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${
            props.SubjectId
          }&LovCategoryId=${props.LovCategoryId}&ParentLovId=${
            props.PId || 0
          }&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetTopicOptions([{ display: "All", value: 0 }, ...Options]);
        let Selected = Options.find(
          (item) => item.value === parseInt(props.SOption)
        );
        props.StoreValue(Selected ? props.SOption : "0");
        // props.StoreValue(Selected ? props.SOption : Options?.[0]?.value);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId === "1" || (props.SubjectId && props.PId)) {
      GetTopic();
    }
  }, [props.PId, props.LID]);

  return (
    <>
      {TopicOptions && (
        <DropdownValues
          className={props.className}
          options={TopicOptions}
          selectoption={props.SOption}
          onChange={(e) => props.onChange(e.target.value)}
          disabled={props.disable}
          labelname={props.labelName}
        />
      )}
    </>
  );
}

// Below is for INQ Based questions drop downs
export function AnswerType(props) {
  const [LovCategoryOptions, SetLovCategoryOptions] = useState();
  const GetLovCategory = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=${props.LovId}&ParentLovId=${props.PID}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
          Name: item.lovName,
        }));
        SetLovCategoryOptions(Options);
        if (props?.Preselect) {
          let Selected = Options.find(
            (item) =>
              item.value === parseInt(props.SOption?.Value || props.SOption)
          );
          props.StoreValue(
            Selected
              ? { Value: Selected.value, Name: Selected.Name }
              : { Value: res.data[0]?.lovId, Name: res.data[0]?.lovName }
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PID && props.HideOption) {
      GetLovCategory();
    } else {
      props.StoreValue("");
    }
  }, [props.PID, props.HideOption]);
  const StoreValues = (e) => {
    const selectedOption = LovCategoryOptions.find(
      (opt) => opt.value === Number(e)
    );
    if (selectedOption) {
      props.onChange({
        Value: selectedOption.value,
        Name: selectedOption.Name,
      });
    }
  };
  return (
    <>
      {props.Type === "Radio" ? (
        <div className="dflex gap-3 mt-4 RadioPanel">
          <label>{props.labelname}</label>
          {LovCategoryOptions?.map((item) => (
            <div className="dflex gap-1 alignitems">
              <input
                disabled={props.disable}
                type="radio"
                value={item?.value}
                name={props.Name}
                checked={item?.value === props.SOption.Value}
                onChange={(e) => StoreValues(e.target.value)}
              />
              {item.display}
            </div>
          ))}
        </div>
      ) : (
        <>
          {props.labelname}
          <select
            value={props.SOption?.Value || props.SOption}
            onChange={(e) => StoreValues(e.target.value)}
            disabled={props.disabled}
            className={props.className}
            name={props.Name}
          >
            {props.Displayname && <option value="">{props.Displayname}</option>}
            {LovCategoryOptions?.length > 0 ? (
              LovCategoryOptions?.map((option, index) => (
                <option key={index} value={option.value}>
                  {" "}
                  {option.display}{" "}
                </option>
              ))
            ) : (
              <option value="">No Options Avaliable</option>
            )}
          </select>
        </>
      )}
    </>
  );
}

export function AnswerValuetype(props) {
  const [LovCategoryOptions, SetLovCategoryOptions] = useState();
  const GetLovCategory = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=${props.LovId}&ParentLovId=${props.PID}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        let Options;
        switch (props.HideOption) {
          case "F":
            Options = res.data.filter((item) => item.lovName !== "R");
            break;
          case "T":
            Options = res.data.filter((item) => item.lovName === "S");
            break;
          default:
            Options = res.data.filter((item) => item.lovName !== "M");
            break;
        }
        const Finialoptions = Options.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
          Name: item.lovName,
        }));
        SetLovCategoryOptions(Finialoptions);
        if (props?.Preselect) {
          let Selected = Finialoptions.find(
            (item) =>
              item.value === parseInt(props.SOption?.Value || props.SOption)
          );
          props.StoreValue(
            Selected
              ? { Value: Selected.value, Name: Selected.Name }
              : { Value: res.data[0]?.lovId, Name: res.data[0]?.lovName }
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PID && props.HideOption) {
      GetLovCategory();
    } else {
      props.StoreValue("");
    }
  }, [props.PID, props.HideOption]);

  const StoreValues = (e) => {
    const selectedOption = LovCategoryOptions.find(
      (opt) => opt.value === Number(e)
    );
    if (selectedOption) {
      props.onChange({
        Value: selectedOption.value,
        Name: selectedOption.Name,
      });
    }
  };
  return (
    <>
      <div className="dflex gap-3 mt-4 RadioPanel">
        <label>{props.labelname}</label>
        {LovCategoryOptions?.map((item) => (
          <div className="dflex gap-1 alignitems">
            <input 
              type="radio"
              disabled={props.disable}
              value={item?.value}
              name={props.Name}
              checked={item?.value === props.SOption.Value}
              onChange={(e) => StoreValues(e.target.value)}
            />
            {item.display}
          </div>
        ))}
      </div>
    </>
  );
}

export function UnitsDD(props) {
  const [LovCategoryOptions, SetLovCategoryOptions] = useState();
  const GetLovCategory = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=${props.LovId}&ParentLovId=${props.PID}&LanguageId=${props.LID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: `${item.lovDescription} (${item.lovName})`,
          value: item.lovId,
        }));
        SetLovCategoryOptions(Options);
        if (props?.Preselect) {
          let Selected = Options.find(
            (item) => item.value === parseInt(props.SOption)
          );
          props.StoreValue(Selected ? Selected.value : res.data[0]?.lovId);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.PID) {
      GetLovCategory();
    } else {
      props.StoreValue("");
    }
  }, [props.PID]);
  // const StoreValues = (e) => {
  //   const selectedOption = LovCategoryOptions.find(
  //     (opt) => opt.value === Number(e)
  //   );
  //   if (selectedOption) {
  //     props.onChange(selectedOption.value);
  //   }
  // };
  return (
    <>
      {props.labelname}
      <select
        value={props.SOption?.Value || props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disabled}
        className={props.className}
        name={props.Name}
      >
        {props.Displayname && <option value="">{props.Displayname}</option>}
        {LovCategoryOptions?.length > 0 ? (
          LovCategoryOptions?.map((option, index) => (
            <option key={index} value={option.value}>
              {option.display}{" "}
            </option>
          ))
        ) : (
          <option value="">No Options Avaliable</option>
        )}
      </select>
    </>
  );
}
// Above is for INQ Based questions drop downs
